import { render, staticRenderFns } from "./simpleList.vue?vue&type=template&id=ad3dfa1c&scoped=true&"
import script from "./simpleList.vue?vue&type=script&lang=js&"
export * from "./simpleList.vue?vue&type=script&lang=js&"
import style0 from "./simpleList.vue?vue&type=style&index=0&id=ad3dfa1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3dfa1c",
  null
  
)

export default component.exports